import {post, get} from '@/utils/request'



/**
 * 获取分期账单列表列表数据
 */
export function getListAPI(data) {
	return post({
		data,
		url: 'tbs/fdBill/fillList'
	})
}

/**
 * 获取分期账单统计数据
 */
export function getStatAPI(data) {
	return post({
		data,
		url: 'tbs/fdBill/fillGroupInfo',
	})
}
